module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_house-ee67ae52a7ea756aafa59b59179a9921.png";